// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1aefba4d","455":"d4b2936b","517":"9049e442","977":"f6415db8"}[chunkId] + ".chunk.js";
};